"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get TargetFactory () {
        return _TargetFactory.TargetFactory;
    },
    get TargetGraphBuilder () {
        return _TargetGraphBuilder.TargetGraphBuilder;
    },
    get WorkspaceTargetGraphBuilder () {
        return _WorkspaceTargetGraphBuilder.WorkspaceTargetGraphBuilder;
    },
    get detectCycles () {
        return _detectCycles.detectCycles;
    },
    get getPackageAndTask () {
        return _targetId.getPackageAndTask;
    },
    get getStartTargetId () {
        return _targetId.getStartTargetId;
    },
    get getTargetId () {
        return _targetId.getTargetId;
    },
    get removeNodes () {
        return _removeNodes.removeNodes;
    },
    get sortTargetsByPriority () {
        return _sortTargetsByPriority.sortTargetsByPriority;
    },
    get transitiveReduction () {
        return _transitiveReduction.transitiveReduction;
    }
});
const _sortTargetsByPriority = require("./sortTargetsByPriority.js");
const _targetId = require("./targetId.js");
const _detectCycles = require("./detectCycles.js");
const _WorkspaceTargetGraphBuilder = require("./WorkspaceTargetGraphBuilder.js");
const _TargetGraphBuilder = require("./TargetGraphBuilder.js");
const _TargetFactory = require("./TargetFactory.js");
const _removeNodes = require("./removeNodes.js");
const _transitiveReduction = require("./transitiveReduction.js");
